(() => {
  const mediaQuery = window.matchMedia('(max-width: 989px)');
  const drawerDetails = document.getElementById('Details-menu-drawer-container');
  const primaryNotice = document.querySelector('[id$="__announcement-bar"]');
  const salesTaxNotice = document.querySelector('[id$="__announcement_bar_EGpazV"]');
  const header = document.querySelector('.section-header');

  if (!drawerDetails || !header) return;

  let lockedScrollY = 0;
  let savedBodyStyles = null;

  const geometryObserver = new ResizeObserver(() => {
    if (document.documentElement.classList.contains('as-mobile-menu-locked')) setGeometry();
  });

  [primaryNotice, salesTaxNotice, header].filter(Boolean).forEach((element) => geometryObserver.observe(element));

  const setGeometry = () => {
    const primaryHeight = primaryNotice?.getBoundingClientRect().height || 0;
    const salesTaxHeight = salesTaxNotice?.getBoundingClientRect().height || 0;
    const headerHeight = header.getBoundingClientRect().height || 0;

    document.documentElement.style.setProperty('--as-menu-primary-notice-height', `${primaryHeight}px`);
    document.documentElement.style.setProperty('--as-menu-notice-stack-height', `${primaryHeight + salesTaxHeight}px`);
    document.documentElement.style.setProperty(
      '--as-menu-fixed-stack-height',
      `${primaryHeight + salesTaxHeight + headerHeight}px`
    );
  };

  const lockPage = () => {
    if (!mediaQuery.matches || document.documentElement.classList.contains('as-mobile-menu-locked')) return;

    lockedScrollY = window.scrollY;
    setGeometry();
    savedBodyStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      right: document.body.style.right,
      left: document.body.style.left,
      width: document.body.style.width,
    };

    document.documentElement.classList.add('as-mobile-menu-locked');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${lockedScrollY}px`;
    document.body.style.right = '0';
    document.body.style.left = '0';
    document.body.style.width = '100%';
    setGeometry();
    requestAnimationFrame(setGeometry);
  };

  const unlockPage = () => {
    if (!document.documentElement.classList.contains('as-mobile-menu-locked')) return;

    document.documentElement.classList.remove('as-mobile-menu-locked');
    document.body.style.position = savedBodyStyles?.position || '';
    document.body.style.top = savedBodyStyles?.top || '';
    document.body.style.right = savedBodyStyles?.right || '';
    document.body.style.left = savedBodyStyles?.left || '';
    document.body.style.width = savedBodyStyles?.width || '';
    window.scrollTo(0, lockedScrollY);
    savedBodyStyles = null;
  };

  drawerDetails.addEventListener('toggle', () => {
    drawerDetails.open ? lockPage() : unlockPage();
  });

  window.addEventListener('resize', () => {
    if (drawerDetails.open && mediaQuery.matches) setGeometry();
    if (!mediaQuery.matches) unlockPage();
  });
})();
